import { render, staticRenderFns } from "./select-group-chat.vue?vue&type=template&id=07533adc&scoped=true"
import script from "./select-group-chat.vue?vue&type=script&lang=js"
export * from "./select-group-chat.vue?vue&type=script&lang=js"
import style0 from "./select-group-chat.vue?vue&type=style&index=0&id=07533adc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07533adc",
  null
  
)

export default component.exports